import React from "react";
import { Modal } from "react-bootstrap";
import TwoFAsetup from "../../pages/TwoFAsetup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
const TwoFAModal = ({ closePopup, fromLogin = false, localData }) => {
  return (
    <Modal size="xl" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Setup Two Factor Authentication</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          <TwoFAsetup
            fromProfile={true}
            closePopup={closePopup}
            fromLogin={fromLogin}
            userData={localData}
          />
        </>
      </Modal.Body>
    </Modal>
  );
};
export default TwoFAModal;
